<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Поиск информации об аккаунтах ByBit
            <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="quickSearch"></v-text-field>
          </span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-data-table class="elevation-1" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" hide-actions>
        <template slot="headers" slot-scope="props">
          <tr>
            <th>Bl</th>
            <th>Никнейм</th>
            <th>UID</th>
            <th>Всего ордеров</th>
            <th>Нег.отз.</th>
            <th>Дней аккаунту</th>
            <th>Оборот</th>
            <th>Вериф</th>
            <th>Добавлен</th>
            <th>Контакты</th>
          </tr>
        </template>
        <template class="body-2" slot="items" slot-scope="props">
              <td>{{ props.item.bl === 0 ? "✅" : "❌" }} 
              <td>{{ props.item.nickname }} </td>
              <td>{{ props.item.user_id }} </td>
              <td>{{ props.item.total_finish_count != 'null' ? props.item.total_finish_count : '' }} </td>
              <td>{{ props.item.bad_appraise_count != 'null' ? props.item.bad_appraise_count : '' }} </td>
              <td>{{ props.item.accountceate_days != 'null' ? props.item.accountceate_days   : '' }} </td>
              <td>{{ props.item.total_trade_amount != 'null' ? props.item.total_trade_amount : '' }} </td>
              <td>{{ props.item.kyc_country_code != 'null' ? props.item.kyc_country_code : '' }} </td>
              <td>{{ props.item.timestamp }}</td>
              <td>{{ props.item.contact === 1 ? "✅" : "" }} 
              <!--td><a :href="'https://bankpdf.ru/mail/' + props.item.file + '.eml'" target="_blank">Открыть</a></td-->
            <td class="text-xs-right">
            <v-btn class="teal" fab small dark @click.native="view(props.item)">
              <v-icon>list</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
         <span>
            <p class="pt-2 blue--text subheading"  v-if="quickSearchFilter != ''">   <v-icon medium class="blue--text" >info</v-icon>Sorry, nothing to display here :(</p>
          </span>
        </template>
      </v-data-table>
      </v-card>
    </v-flex>
      <v-snackbar v-if="loading===false" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* globals Store */
import Table from "@/components/Table.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    Table,
  },
  data () {
    return {
      right: true,
      search: '',
      headers: [
        { text: 'Площадка', left: true, value: 'market' },
        { text: 'Nick Name', left: true, value: 'nickname' },
        { text: 'UID', value: 'user_id' },
        { text: 'Кол-во отзывов', value: 'count' },
        { text: 'Добавлен', value: 'report_time' },
      ],
      customerId: "",
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
    }
  },
  methods: {
    view (item) {
      this.$router.push({ name: 'ContragentForm', params: { id: item.user_id, nickname: item.nickname, link: item.link } })
    },
    dashboard () {
      this.$router.push('Dashboard')
    },
    renderData: (item, header) => {
      let val = "";
      if (header.value.includes('.')) {
        const vals = header.value.split('.')
        val = vals.reduce((acc, val) => acc[val], item)
      } else {
        val = item[header.value]
      }
      if (typeof val === "boolean") {
        val = val ? "Yes" : "No";
      }
      return val;
    },
    quickSearchCustomers: debounce(function () {
      console.log(this.quickSearchFilter)
      this.$Progress.start();
      Store.dispatch("contragents/quickSearch",
       { headers: this.headers,
         qsFilter: this.quickSearchFilter.toLowerCase(),
         pagination: this.pagination });
    }, 300),
  },
  watch: {
    items() {
      this.$Progress.finish();
    },
  },
  computed: {
    ...mapState("contragents", {
      items: "items",
      loading: "loading",
      mode: "mode",
      snackbar: "snackbar",
      notice: "notice"
    }),
    quickSearch: {
      get: function () {
        return this.quickSearchFilter;
      },
      set: function ( val ) {
        this.quickSearchFilter = val;
        this.quickSearchCustomers();
      }
    }
  },
  created () {
    Store.dispatch("contragents/quickSearch",
       { headers: this.headers,
         qsFilter: this.quickSearchFilter.toLowerCase(),
         pagination: this.pagination });
  },
}
</script>



// WEBPACK FOOTER //
// ContragentList.vue?db395f3a